import { ModpackPicker } from '../components/ModpackPicker';
import { SoftwarePicker } from '../components/SoftwarePicker';
import type { Template } from '../api/types-p3';
import type { ModpackPreview } from '@mcpanel/core';
import type { SoftwareSpec } from '../api/types';
export type CreateMethod = 'empty' | 'template' | 'modpack';
export function CreateSourceFields({
  method,
  templates,
  templateId,
  applyTemplate,
  modpack,
  setModpack,
  selectModpack,
  software,
  setSoftware,
  changeSoftware,
}: {
  method: CreateMethod;
  templates?: Template[];
  templateId: string;
  applyTemplate: (template: Template | undefined) => void;
  modpack?: ModpackPreview;
  setModpack: (pack: ModpackPreview | undefined) => void;
  selectModpack: (pack: ModpackPreview) => void;
  software: SoftwareSpec;
  setSoftware: (software: SoftwareSpec) => void;
  changeSoftware: (software: SoftwareSpec) => void;
}) {
  return (
    <>
      {method === 'template' && (
        <section className="card card-body stack" style={{ gap: 10 }}>
          <h2>テンプレート</h2>
          <select
            className="input"
            value={templateId}
            onChange={(e) => applyTemplate(templates?.find((t) => t.id === e.target.value))}
            aria-label="テンプレート"
          >
            <option value="">選択してください</option>
            {templates?.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
                {t.mods.length > 0 ? `（Mod ${t.mods.length} 個）` : ''}
              </option>
            ))}
          </select>
          {templateId && (
            <p className="small faint" style={{ margin: 0 }}>
              {templates?.find((t) => t.id === templateId)?.description ??
                'テンプレートの内容を下の項目に反映しました。必要なら変更できます。'}
            </p>
          )}
        </section>
      )}

      {method === 'modpack' && (
        <section className="card card-body stack">
          <ModpackPicker onPending={() => setModpack(undefined)} onSelect={selectModpack} />
          {modpack && (
            <p>
              {modpack.identity.name} {modpack.identity.versionNumber} / Mod {modpack.modCount} 個 / 推奨ヒープ{' '}
              {modpack.recommendedMemoryMb / 1024} GB（変更できます）
            </p>
          )}
        </section>
      )}
      {method !== 'modpack' && (method === 'empty' || templateId) && (
        <section className="card card-body stack">
          <h2>ソフトとバージョン</h2>
          <SoftwarePicker value={software} onChange={changeSoftware} />
        </section>
      )}
      {modpack && (
        <section className="card card-body stack">
          <h2>ソフトとバージョン</h2>
          <SoftwarePicker value={software} onChange={setSoftware} />
          <p>
            {software.family} / Minecraft {software.mcVersion} / ローダー {software.loaderVersion}
          </p>
        </section>
      )}
    </>
  );
}
